import { FormInputGroup } from 'components/form';
import styles from './OfflineLedSequences.module.scss';
import {
    FormRadio,
    FormRadioOption,
} from 'components/form/FormRadio/FormRadio';
import { Box, Tooltip } from '@mui/material';
import { ArrowForward, HelpOutline } from '@mui/icons-material';
import { useFormContext } from 'react-hook-form';

const ledSequenceDescriptions: Record<string, string> = {
    normalTransmission: `These are the normal LEDs. If aqua is seen then it can be assumed its normal behavior.
    Yellow 'knight rider' LEDs after a transmission means the monitor is taking an update.`,
    sleepTransmission:
        'Sleep mode is entered when the magnet is held beyond the typical 3 seconds required to trigger. If the magnet is released when all three red LEDs are on, it will transmit then go to sleep.',
    assemblyMode:
        'A monitor is in assembly mode when three white LEDs fade in one by one. This mode has a menu indicated by yellow LEDs. Assembly mode needs to be exited. Refer to guide to enter customer mode.',
    inspectionMode:
        'Inspection mode is entered when the user holds the magnet beyond sleep mode, until there are 3 green LEDs. Each LED could be either blue or red, and the last can blink. This mode exits after a minute.',
    lowBattery:
        'Three red LEDs that turn on without any interaction indicate low battery. Rapidly flashing or erratic LEDs is an indication that the monitor does not have enough voltage to stay on.',
    other: 'Please describe the LED color sequence in the description on the Details tab.',
};

export const NormalTransmissionSeq = () => {
    return (
        <Box className={styles.ledSequenceGroup}>
            <Box className={styles.ledGroup}>
                <Box className={styles.led} sx={{ backgroundColor: 'aqua' }} />
                <Box className={styles.led} sx={{ backgroundColor: 'gray' }} />
                <Box className={styles.led} sx={{ backgroundColor: 'gray' }} />
            </Box>
            <ArrowForward />
            <Box className={styles.ledGroup}>
                <Box className={styles.led} sx={{ backgroundColor: 'aqua' }} />
                <Box className={styles.led} sx={{ backgroundColor: 'aqua' }} />
                <Box className={styles.led} sx={{ backgroundColor: 'aqua' }} />
            </Box>
            <ArrowForward />
            <Box className={styles.ledGroup}>
                <Box
                    className={styles.led}
                    sx={{ backgroundColor: 'yellow' }}
                />
                <Box
                    className={styles.led}
                    sx={{ backgroundColor: 'yellow' }}
                />
                <Box
                    className={styles.led}
                    sx={{ backgroundColor: 'yellow' }}
                />
            </Box>
        </Box>
    );
};

export const SleepTransmissionSeq = () => {
    return (
        <Box className={styles.ledSequenceGroup}>
            <Box className={styles.ledGroup}>
                <Box className={styles.led} sx={{ backgroundColor: 'red' }} />
                <Box className={styles.led} sx={{ backgroundColor: 'gray' }} />
                <Box className={styles.led} sx={{ backgroundColor: 'gray' }} />
            </Box>
            <ArrowForward />
            <Box className={styles.ledGroup}>
                <Box className={styles.led} sx={{ backgroundColor: 'red' }} />
                <Box className={styles.led} sx={{ backgroundColor: 'red' }} />
                <Box className={styles.led} sx={{ backgroundColor: 'gray' }} />
            </Box>
            <ArrowForward />
            <Box className={styles.ledGroup}>
                <Box className={styles.led} sx={{ backgroundColor: 'red' }} />
                <Box className={styles.led} sx={{ backgroundColor: 'red' }} />
                <Box className={styles.led} sx={{ backgroundColor: 'red' }} />
            </Box>
        </Box>
    );
};

export const AssemblyModeSeq = () => {
    return (
        <Box className={styles.ledSequenceGroup}>
            <Box className={styles.ledGroup}>
                <Box className={styles.led} sx={{ backgroundColor: 'white' }} />
                <Box className={styles.led} sx={{ backgroundColor: 'white' }} />
                <Box className={styles.led} sx={{ backgroundColor: 'white' }} />
            </Box>
            <ArrowForward />
            <Box className={styles.ledGroup}>
                <Box className={styles.led} sx={{ backgroundColor: 'white' }} />
                <Box className={styles.led} sx={{ backgroundColor: 'white' }} />
                <Box
                    className={styles.led}
                    sx={{ backgroundColor: 'yellow' }}
                />
            </Box>
            <ArrowForward />
            <Box className={styles.ledGroup}>
                <Box className={styles.led} sx={{ backgroundColor: 'white' }} />
                <Box className={styles.led} sx={{ backgroundColor: 'gray' }} />
                <Box className={styles.led} sx={{ backgroundColor: 'gray' }} />
            </Box>
        </Box>
    );
};

export const InspectionModeSeq = () => {
    return (
        <Box className={styles.ledSequenceGroup}>
            <Box className={styles.ledGroup}>
                <Box className={styles.led} sx={{ backgroundColor: 'green' }} />
                <Box className={styles.led} sx={{ backgroundColor: 'green' }} />
                <Box className={styles.led} sx={{ backgroundColor: 'green' }} />
            </Box>
            <ArrowForward />
            <Box className={styles.ledGroup}>
                <Box className={styles.led} sx={{ backgroundColor: 'blue' }} />
                <Box className={styles.led} sx={{ backgroundColor: 'blue' }} />
                <Box className={styles.led} sx={{ backgroundColor: 'blue' }} />
            </Box>
            <ArrowForward />
            <Box className={styles.sequenceBranchGroup}>
                <Box className={styles.ledGroup}>
                    <Box
                        className={styles.led}
                        sx={{ backgroundColor: 'blue' }}
                    />
                    <Box
                        className={styles.led}
                        sx={{ backgroundColor: 'blue' }}
                    />
                    <Box
                        className={styles.led}
                        sx={{ backgroundColor: 'blue' }}
                    />
                </Box>
                OR
                <Box className={styles.ledGroup}>
                    <Box
                        className={styles.led}
                        sx={{ backgroundColor: 'blue' }}
                    />
                    <Box
                        className={styles.led}
                        sx={{ backgroundColor: 'blue' }}
                    />
                    <Box
                        className={styles.led}
                        sx={{ backgroundColor: 'red' }}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export const LowBatterySeq = () => {
    return (
        <Box className={styles.sequenceBranchGroup}>
            <Box className={styles.ledSequenceGroup}>
                <Box className={styles.ledGroup}>
                    <Box
                        className={styles.led}
                        sx={{ backgroundColor: 'red' }}
                    />
                    <Box
                        className={styles.led}
                        sx={{ backgroundColor: 'red' }}
                    />
                    <Box
                        className={styles.led}
                        sx={{ backgroundColor: 'red' }}
                    />
                </Box>
                <ArrowForward />
                <Box className={styles.ledGroup}>
                    <Box
                        className={styles.led}
                        sx={{ backgroundColor: 'red' }}
                    />
                    <Box
                        className={styles.led}
                        sx={{ backgroundColor: 'red' }}
                    />
                    <Box
                        className={styles.led}
                        sx={{ backgroundColor: 'red' }}
                    />
                </Box>
            </Box>
            OR
            <Box className={styles.ledSequenceGroup}>
                <Box className={styles.ledGroup}>
                    <Box
                        className={styles.led}
                        sx={{ backgroundColor: 'white' }}
                    />
                    <Box
                        className={styles.led}
                        sx={{ backgroundColor: 'white' }}
                    />
                    <Box
                        className={styles.led}
                        sx={{ backgroundColor: 'white' }}
                    />
                </Box>
                <ArrowForward />
                <Box className={styles.ledGroup}>
                    <Box
                        className={styles.led}
                        sx={{ backgroundColor: 'gray' }}
                    />
                    <Box
                        className={styles.led}
                        sx={{ backgroundColor: 'gray' }}
                    />
                    <Box
                        className={styles.led}
                        sx={{ backgroundColor: 'gray' }}
                    />
                </Box>
                <ArrowForward />
                <Box className={styles.ledGroup}>
                    <Box
                        className={styles.led}
                        sx={{ backgroundColor: 'white' }}
                    />
                    <Box
                        className={styles.led}
                        sx={{ backgroundColor: 'white' }}
                    />
                    <Box
                        className={styles.led}
                        sx={{ backgroundColor: 'white' }}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export const ledSequenceOptions: FormRadioOption[] = [
    {
        value: 'normalTransmission',
        name: 'Normal Transmission',
        afterChildren: <NormalTransmissionSeq />,
    },
    {
        value: 'sleepTransmission',
        name: 'Sleep Transmission',
        afterChildren: <SleepTransmissionSeq />,
    },
    {
        value: 'assemblyMode',
        name: 'Assembly Mode',
        afterChildren: <AssemblyModeSeq />,
    },
    {
        value: 'inspectionMode',
        name: 'Inspection Mode',
        afterChildren: <InspectionModeSeq />,
    },
    {
        value: 'lowBattery',
        name: 'Low Battery',
        afterChildren: <LowBatterySeq />,
    },
    { value: 'other', name: 'Other: None of the Above' },
];

interface OfflineLedSequencesProps {
    hasUnknownOption?: boolean;
}

export const OfflineLedSequences = ({
    hasUnknownOption,
}: OfflineLedSequencesProps) => {
    const { watch } = useFormContext();

    const selectedLedSequence = watch('selectedLedSequence');

    const options = hasUnknownOption
        ? [
              ...ledSequenceOptions,
              // eslint-disable-next-line quotes
              { value: 'unknown', name: "Don't Know / Not Available" },
          ]
        : ledSequenceOptions;

    return (
        <div
            data-testid="OfflineLedSequences"
            className={styles.OfflineLedSequences}
        >
            <FormInputGroup>
                {ledSequenceDescriptions[selectedLedSequence]}
                <FormRadio
                    horizontal
                    field="selectedLedSequence"
                    options={options}
                    optionClassName={styles.options}
                    label="Observed LED Sequence"
                    labelAdornment={
                        <Tooltip title="Please select the LED sequence seen on the monitor.">
                            <HelpOutline
                                fontSize="small"
                                sx={{ marginLeft: '5px' }}
                            />
                        </Tooltip>
                    }
                />
            </FormInputGroup>
        </div>
    );
};
